import { Table } from "antd";
import React from "react";
import "./repricing-gap-table.scss";
import { useTranslation } from "react-i18next";
import TableNumber from "../../../../../atoms/table-number";

const RepricingGapTable = () => {
    const { t } = useTranslation();

    const assetsData = [
        {
            key: '1',
            assets: 'Assets:',
            overnight: '',
            '1m': '',
            '2m': '',
            '3m': '',
            '4m': '',
            '5m': '',
            '6m': '',
            '7-12m': '',
            '1-2y': '',
            '2-3y': '',
            '3-4y': '',
            '4-5y': '',
            '>5y': '',
            'nonSentitive': '',
            'grandTotal': '',
        },
        {
            key: '2',
            assets: 'Cash',
            overnight: '',
            '1m': '',
            '2m': '',
            '3m': '',
            '4m': '',
            '5m': '',
            '6m': '',
            '7-12m': '',
            '1-2y': '',
            '2-3y': '',
            '3-4y': '',
            '4-5y': '',
            '>5y': '',
            'nonSentitive': '12,472',
            'grandTotal': '12.472',
        },
        {
            key: '3',
            assets: 'Due From Banks',
            overnight: '6,530',
            '1m': '3,302',
            '2m': '225',
            '3m': '19',
            '4m': '0',
            '5m': '0',
            '6m': '0',
            '7-12m': '113',
            '1-2y': '0',
            '2-3y': '0',
            '3-4y': '0',
            '4-5y': '0',
            '>5y': '0',
            'nonSentitive': '0',
            'grandTotal': '10,189',
        },
        {
            key: '4',
            assets: 'International Portfolios',
            overnight: '0',
            '1m': '148',
            '2m': '225',
            '3m': '30',
            '4m': '63',
            '5m': '35',
            '6m': '48',
            '7-12m': '382',
            '1-2y': '867',
            '2-3y': '924',
            '3-4y': '539',
            '4-5y': '587',
            '>5y': '3,263',
            'nonSentitive': '0',
            'grandTotal': '7,113',
        },

        {
            key: '5',
            assets: 'Domestic Bonds',
            overnight: '0',
            '1m': '1,489',
            '2m': '916',
            '3m': '2,305',
            '4m': '610',
            '5m': '1,002',
            '6m': '1,089',
            '7-12m': '14,047',
            '1-2y': '960',
            '2-3y': '1,001',
            '3-4y': '487',
            '4-5y': '1,003',
            '>5y': '2,613',
            'nonSentitive': '',
            'grandTotal': '27,533',
        },

        {
            key: '6',
            assets: 'Loans & Advances (Gross)',
            overnight: '10,930',
            '1m': '35,976',
            '2m': '17,947',
            '3m': '8,645',
            '4m': '3,194',
            '5m': '3,264',
            '6m': '3,267',
            '7-12m': '16,142',
            '1-2y': '11,860',
            '2-3y': '9,785',
            '3-4y': '7,301',
            '4-5y': '3,311',
            '>5y': '3,758',
            'nonSentitive': '0',
            'grandTotal': '135,579',
        },

        {
            key: '7',
            assets: 'Other Assets',
            overnight: '',
            '1m': '',
            '2m': '',
            '3m': '',
            '4m': '',
            '5m': '',
            '6m': '',
            '7-12m': '',
            '1-2y': '',
            '2-3y': '',
            '3-4y': '',
            '4-5y': '',
            '>5y': '',
            'nonSentitive': '6,405',
            'grandTotal': '6,405',
        },

        {
            key: '8',
            assets: 'Total Assets',
            overnight: '17,460',
            '1m': '40,914',
            '2m': '19,314',
            '3m': '10,999',
            '4m': '3,867',
            '5m': '4,301',
            '6m': '4,403',
            '7-12m': '30,684',
            '1-2y': '13,687',
            '2-3y': '11,732',
            '3-4y': '8,328',
            '4-5y': '4,902',
            '>5y': '9,634',
            'nonSentitive': '18,876',
            'grandTotal': '199,090',
        },
    ];

    const liabilitiesData = [
        {
            key: '1',
            assets: 'Liabilities:',
            overnight: '',
            '1m': '',
            '2m': '',
            '3m': '',
            '4m': '',
            '5m': '',
            '6m': '',
            '7-12m': '',
            '1-2y': '',
            '2-3y': '',
            '3-4y': '',
            '4-5y': '',
            '>5y': '',
            'nonSentitive': '',
            'grandTotal': '',
        },
        {
            key: '2',
            assets: 'Due To Banks',
            overnight: '(1,466)',
            '1m': '(1,293)',
            '2m': '(1,271)',
            '3m': '(1,040)',
            '4m': '0',
            '5m': '(97)',
            '6m': '0',
            '7-12m': '0',
            '1-2y': '0',
            '2-3y': '0',
            '3-4y': '0',
            '4-5y': '0',
            '>5y': '0',
            'nonSentitive': '0',
            'grandTotal': '(5,167)',
        },
        {
            key: '3',
            assets: 'Customer Deposits',
            overnight: '(81)',
            '1m': '(24,272)',
            '2m': '(9,001)',
            '3m': '(14,514)',
            '4m': '(5,610)',
            '5m': '(1,784)',
            '6m': '(7,501)',
            '7-12m': '(10,427)',
            '1-2y': '(41)',
            '2-3y': '0',
            '3-4y': '0',
            '4-5y': '(28)',
            '>5y': '0',
            'nonSentitive': '0',
            'grandTotal': '(73,259)',
        },
        {
            key: '4',
            assets: 'Customer Deposits',
            overnight: '0',
            '1m': '0',
            '2m': '0',
            '3m': '0',
            '4m': '0',
            '5m': '0',
            '6m': '0',
            '7-12m': '0',
            '1-2y': '0',
            '3-4y': '0',
            '4-5y': '0',
            '>5y': '0',
            'nonSentitive': '(81,840)',
            'grandTotal': '(81,840)',
        },

        {
            key: '5',
            assets: 'Debt Security',
            overnight: '0',
            '1m': '0',
            '2m': '4,000',
            '3m': '0',
            '4m': '0',
            '5m': '0',
            '6m': '0',
            '7-12m': '0',
            '1-2y': '0',
            '2-3y': '0',
            '3-4y': '0',
            '4-5y': '0',
            '>5y': '0',
            'nonSentitive': '4,000',
            'grandTotal': '0',
        },

        {
            key: '6',
            assets: 'Other Liabilities',
            overnight: '',
            '1m': '',
            '2m': '',
            '3m': '',
            '4m': '',
            '5m': '',
            '6m': '',
            '7-12m': '',
            '1-2y': '',
            '2-3y': '',
            '3-4y': '',
            '4-5y': '',
            '>5y': '',
            'nonSentitive': '(8,952)',
            'grandTotal': '(8,952)',
        },

        {
            key: '7',
            assets: 'Total Liabilities',
            overnight: '(1,547)',
            '1m': '(29,565)',
            '2m': '(10,272)',
            '3m': '(15,554)',
            '4m': '(5,610)',
            '5m': '(1,880)',
            '6m': '(7,501)',
            '7-12m': '(10,427)',
            '1-2y': '(41)',
            '2-3y': '0',
            '3-4y': '0',
            '4-5y': '(28)',
            '>5y': '0',
            'nonSentitive': '(90,792)',
            'grandTotal': '(173,218)',
        },
        {
            key: '8',
            assets: 'Total Equity',
            overnight: '0',
            '1m': '0',
            '2m': '0',
            '3m': '0',
            '4m': '0',
            '5m': '0',
            '6m': '0',
            '7-12m': '0',
            '1-2y': '0',
            '2-3y': '0',
            '3-4y': '0',
            '4-5y': '0',
            '>5y': '0',
            'nonSentitive': '(35,537)',
            'grandTotal': '',
        },
        {
            key: '10',
            assets: 'Total Liabilities & Equity',
            overnight: '(1,547)',
            '1m': '(29,565)',
            '2m': '(10,272)',
            '3m': '(15,554)',
            '4m': '(5,610)',
            '5m': '(1,880)',
            '6m': '(7,501)',
            '7-12m': '(10,427)',
            '1-2y': '(41)',
            '2-3y': '0',
            '3-4y': '0',
            '4-5y': '(28)',
            '>5y': '0',
            'nonSentitive': '(126,329)',
            'grandTotal': '(208,755)',
        },

        {
            key: '11',
            assets: 'Off Balance Sheet (IRS)',
            overnight: '0',
            '1m': '0',
            '2m': '(119)',
            '3m': '(75)',
            '4m':'0',
            '5m': '0',
            '6m': '0',
            '7-12m': '0',
            '1-2y': '(450)',
            '2-3y': '194',
            '3-4y': '0',
            '4-5y': '0',
            '>5y': '450',
            'nonSentitive': '0',
            'grandTotal': '0',
        },
    ];


    const periodCumulativeData = [
        {
            key: '1',
            assets: 'Period Gap',
            overnight: '15,912',
            '1m': '11,349',
            '2m': '8,923',
            '3m': '(4,630)',
            '4m': '(1,743)',
            '5m': '2,421',
            '6m': '(3,098)',
            '7-12m': '20,257',
            '1-2y': '13,196',
            '2-3y': '11,914',
            '3-4y': '8,328',
            '4-5y': '4,873',
            '>5y': '10,084',
            'nonSentitive': '(107,453)',
            'grandTotal': '(9,665)',
        },
        {
            key: '2',
            assets: 'Cumulative Gap',
            overnight: '15,912',
            '1m': '27,261',
            '2m': '36,184',
            '3m': '31,554',
            '4m': '29,812',
            '5m': '32,233',
            '6m': '29,135',
            '7-12m': '49,392',
            '1-2y': '62,589',
            '2-3y': '74,503',
            '3-4y': '82,831',
            '4-5y': '87,704',
            '>5y': '97,788',
            'nonSentitive': '(9,665)',
            'grandTotal': '',
        },
    ];

    const columns = [
        {
            title: '',
            dataIndex: 'assets',
            key: 'assets',
            width: 200,
            fixed: 'left' as const,
            render: (text: string) => text === 'Assets:' || text === 'Liabilities:' ? <b>{text}</b> : text
        },
        {
            title: 'Overnight',
            dataIndex: 'overnight',
            key: 'overnight',
            align: 'center' as const,
            with: 85,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '1m',
            dataIndex: '1m',
            key: '1m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '2m',
            dataIndex: '2m',
            key: '2m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },

        {
            title: '3m',
            dataIndex: '3m',
            key: '3m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '4m',
            dataIndex: '4m',
            key: '4m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '5m',
            dataIndex: '5m',
            key: '5m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '6m',
            dataIndex: '6m',
            key: '6m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '7 - 12m',
            dataIndex: '7-12m',
            key: '7-12m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '1 - 2y',
            dataIndex: '1-2y',
            key: '1-2y',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '2 - 3y',
            dataIndex: '2-3y',
            key: '2-3y',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '3 - 4y',
            dataIndex: '3-4y',
            key: '3-4y',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '4 - 5y',
            dataIndex: '4-5y',
            key: '4-5y',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '> 5y',
            dataIndex: '>5y',
            key: '>5y',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: 'Non-sentitive',
            dataIndex: 'nonSentitive',
            key: 'nonSentitive',
            align: 'center' as const,
            width: 110,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: 'Grand Total',
            dataIndex: 'grandTotal',
            key: 'grandTotal',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
    ];

    return (
        <div className="repricing-gap-wrapper">
            <div className="repricing-table">
                <div className="repricing-table__heading">{t("AssetLiability.repricingGapReport")}</div>
                <div className="repricing-table__date">05/31/2024 · CAD {t("AssetLiability.inMillions")}</div>
                <div className="repricing-table__table" >
                    <Table
                        scroll={{ x: 1460 }}
                        rowClassName={(record, index) => index % 2 === 0 ? 
                            'repricing-table__table__white' : 
                            'repricing-table__light-blue'
                        }
                        dataSource={assetsData}
                        columns={columns}
                        pagination={false}
                    />
                </div>


                <div className="repricing-table__table liabilities" >
                    <Table
                        scroll={{ x: 1460 }}
                        rowClassName={(record, index) => index % 2 === 0 ? 'repricing-table__table__white' : 'repricing-table__light-blue'}
                        dataSource={liabilitiesData}
                        columns={columns}
                        pagination={false}
                    />
                </div>

                <div className="repricing-table__table periodCumulative" >
                    <Table
                        scroll={{ x: 1460 }}
                        rowClassName='repricing-table__orange'
                        dataSource={periodCumulativeData}
                        columns={columns}
                        pagination={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default RepricingGapTable;
